export default {
  name: "Content",
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    contentList() {
      let list = this.data.verDesc.split("\r\n");
      return list;
    }
  }
};